import { Hash, TrendingUp, Zap, FlaskConical, BarChart3, Wrench, Dna, Star, Wallet, Building2, Heart, Settings, Stethoscope, Type } from 'lucide-react';

export const calculatorCategories = [
  {
    id: 'featured', name: 'Featured', icon: Star, featured: true, description: 'Most popular tools',
    calculators: [
      { id: 'unit-converter', name: 'Unit Converter', desc: 'Length, mass, temperature, currency and more' },
      { id: 'currency', name: 'Currency Converter', desc: 'Exchange rates for 160+ world currencies' },
    ],
  },
  {
    id: 'finance', name: 'Finance & Money', icon: Wallet, description: 'EMI, mortgage, SIP, GST, salary & more',
    calculators: [
      { id: 'emi', name: 'EMI / Loan Calculator', desc: 'Monthly EMI, amortisation table, charts' },
      { id: 'mortgage', name: 'Mortgage Calculator', desc: 'Monthly payment with tax & insurance' },
      { id: 'compound-interest', name: 'Compound Interest', desc: 'Growth with daily/monthly/annual compounding' },
      { id: 'sip', name: 'SIP Calculator', desc: 'Systematic investment plan returns' },
      { id: 'gst', name: 'GST / VAT Calculator', desc: 'Add or remove tax with quick rate buttons' },
      { id: 'salary', name: 'Salary Calculator', desc: 'Take-home pay by country' },
      { id: 'discount', name: 'Discount Calculator', desc: 'Original price, discount %, savings' },
      { id: 'profit-loss', name: 'Profit & Loss / Margin', desc: 'Margin %, markup %, break-even' },
      { id: 'roi', name: 'ROI Calculator', desc: 'Return on investment & annualised return' },
      { id: 'tip', name: 'Tip Calculator', desc: 'Tip amount, total, per person split' },
      { id: 'ppf', name: 'PPF Calculator', desc: 'Public Provident Fund maturity value' },
      { id: 'inflation', name: 'Inflation Calculator', desc: 'Purchasing power over time' },
    ],
  },
  {
    id: 'construction', name: 'Construction & Architecture', icon: Building2, description: 'Concrete, paint, tiles, bricks, roofing',
    calculators: [
      { id: 'concrete', name: 'Concrete / Cement Calculator', desc: 'Volume, cement bags, sand, aggregate' },
      { id: 'paint', name: 'Paint Calculator', desc: 'Wall area, litres needed, cans required' },
      { id: 'tile', name: 'Tile Calculator', desc: 'Tiles needed, boxes, grout estimate' },
      { id: 'brick', name: 'Brick & Mortar Calculator', desc: 'Bricks, mortar volume, cement, sand' },
      { id: 'roof', name: 'Roof Calculator', desc: 'Roof area, rafter length, materials' },
      { id: 'flooring', name: 'Flooring Calculator', desc: 'Planks/tiles, boxes, cost estimate' },
      { id: 'rebar', name: 'Steel Rebar Calculator', desc: 'Weight per metre, total weight, bars' },
      { id: 'staircase', name: 'Staircase Calculator', desc: 'Steps, riser, tread, angle' },
      { id: 'sand-aggregate', name: 'Sand & Aggregate', desc: 'Volume, weight, bulk bags' },
      { id: 'room-area', name: 'Room Area & Volume', desc: 'Floor, wall, ceiling area, AC load' },
    ],
  },
  {
    id: 'health-fitness', name: 'Health & Fitness', icon: Heart, description: 'Calories, macros, body fat, running pace',
    calculators: [
      { id: 'calorie', name: 'Calorie / TDEE Calculator', desc: 'BMR, TDEE, goal calories' },
      { id: 'macro', name: 'Macro Calculator', desc: 'Protein, carbs, fat breakdown' },
      { id: 'one-rep-max', name: 'One Rep Max (1RM)', desc: 'Epley, Brzycki, percentage table' },
      { id: 'running-pace', name: 'Running Pace Calculator', desc: 'Pace, speed, race predictions' },
      { id: 'water-intake', name: 'Water Intake Calculator', desc: 'Daily water by weight & activity' },
      { id: 'body-fat', name: 'Body Fat % Calculator', desc: 'US Navy method, lean/fat mass' },
      { id: 'pregnancy', name: 'Pregnancy Due Date', desc: 'EDD, gestational age, trimesters' },
      { id: 'vo2max', name: 'VO2 Max Estimator', desc: 'Cooper test, fitness category' },
      { id: 'heart-rate', name: 'Heart Rate Zones', desc: 'Max HR, 5 zones with BPM ranges' },
      { id: 'sleep-cycle', name: 'Sleep Cycle Calculator', desc: 'Best wake/sleep times by cycles' },
    ],
  },
  {
    id: 'engineering', name: 'Engineering Standards', icon: Settings, description: 'O-ring, bolt, pipe, wire, bearing charts',
    calculators: [
      { id: 'oring', name: 'O-Ring Sizes', desc: 'AS568, ISO 3601, BS1806 standards' },
      { id: 'bolt', name: 'Bolt & Nut Sizes', desc: 'Metric & imperial with torque calc' },
      { id: 'pipe', name: 'Pipe & Tube Sizes', desc: 'NPS/DN schedules, wall thickness' },
      { id: 'wire-gauge', name: 'Wire & Cable Gauge', desc: 'AWG/SWG to mm, resistance, current' },
      { id: 'sheet-metal', name: 'Sheet Metal Gauge', desc: 'Gauge to thickness conversion' },
      { id: 'bearing', name: 'Bearing Sizes', desc: '6000/6200/6300 series lookup' },
      { id: 'drill-bit', name: 'Drill Bit Sizes', desc: 'Metric, imperial, letter, number' },
    ],
  },
  {
    id: 'medical', name: 'Medical Reference', icon: Stethoscope, description: 'Needle gauges, catheter, IV cannula, sutures',
    calculators: [
      { id: 'needle', name: 'Syringe & Needle Sizes', desc: 'Gauge chart 7G–34G with colour codes' },
      { id: 'catheter', name: 'Catheter Sizes (French)', desc: 'Fr to mm conversion chart' },
      { id: 'suture', name: 'Suture Sizes', desc: 'USP sizes, materials, uses' },
      { id: 'iv-cannula', name: 'IV Cannula Sizes', desc: '14G–26G with flow rates & colours' },
      { id: 'et-tube', name: 'ET Tube Sizes', desc: 'Size by age/weight table' },
      { id: 'bp-reference', name: 'Blood Pressure Reference', desc: 'AHA categories & guidelines' },
      { id: 'drug-dosage', name: 'Drug Dosage Calculator', desc: 'mg/kg dosing, liquid volume' },
      { id: 'medical-converter', name: 'Medical Unit Converter', desc: 'Body temp, blood sugar, cholesterol' },
    ],
  },
  {
    id: 'mathematics', name: 'Mathematics', icon: Hash, description: 'Equations, matrices, number theory',
    calculators: [
      { id: 'scientific', name: 'Scientific Calculator', desc: 'Full expression engine' },
      { id: 'eq-solver', name: 'Equation Solver', desc: 'Linear, quadratic, cubic, systems' },
      { id: 'matrix', name: 'Matrix Calculator', desc: 'Add, multiply, determinant, inverse' },
      { id: 'complex', name: 'Complex Numbers', desc: 'Polar & rectangular operations' },
      { id: 'base', name: 'Number Base Converter', desc: 'Binary, octal, decimal, hex' },
      { id: 'prime', name: 'Prime Factorisation', desc: 'GCD, LCM, primality test' },
    ],
  },
  {
    id: 'calculus', name: 'Calculus & Algebra', icon: TrendingUp, description: 'Derivatives, integrals, graphing',
    calculators: [
      { id: 'derivative', name: 'Derivative Calculator', desc: 'Numerical differentiation' },
      { id: 'integral', name: 'Integral Calculator', desc: "Definite integration (Simpson's)" },
      { id: 'limit', name: 'Limit Calculator', desc: 'One-sided, at infinity' },
      { id: 'series', name: 'Series & Sequences', desc: 'Taylor, summation, convergence' },
      { id: 'grapher', name: 'Function Grapher', desc: 'Plot, zoom, root finding' },
    ],
  },
  {
    id: 'physics', name: 'Physics', icon: Zap, description: 'Mechanics, electromagnetism, relativity',
    calculators: [
      { id: 'kinematics', name: 'Kinematics', desc: 'SUVAT, projectile, circular motion' },
      { id: 'newtons-laws', name: "Newton's Laws", desc: 'Force, friction, tension' },
      { id: 'energy', name: 'Energy & Work', desc: 'KE, PE, power, efficiency' },
      { id: 'electromagnetism', name: 'Electromagnetism', desc: "Ohm's law, capacitance" },
      { id: 'optics', name: 'Optics', desc: "Snell's law, lens equation" },
      { id: 'thermodynamics', name: 'Thermodynamics', desc: 'Ideal gas, Carnot, entropy' },
      { id: 'waves', name: 'Waves & Sound', desc: 'Frequency, Doppler, decibels' },
      { id: 'relativity', name: 'Special Relativity', desc: 'Time dilation, E=mc²' },
    ],
  },
  {
    id: 'chemistry', name: 'Chemistry', icon: FlaskConical, description: 'Molar mass, pH, gas laws',
    calculators: [
      { id: 'molar-mass', name: 'Molar Mass', desc: 'Parse formula, molecular weight' },
      { id: 'stoichiometry', name: 'Stoichiometry', desc: 'Mole ratios, limiting reagent' },
      { id: 'ph', name: 'pH & Titration', desc: 'Henderson-Hasselbalch' },
      { id: 'gas-laws', name: 'Gas Laws', desc: 'Boyle, Charles, ideal gas' },
      { id: 'electrochemistry', name: 'Electrochemistry', desc: 'Nernst equation' },
      { id: 'nuclear', name: 'Nuclear & Radioactivity', desc: 'Half-life, decay, binding energy' },
    ],
  },
  {
    id: 'statistics', name: 'Statistics & Probability', icon: BarChart3, description: 'Descriptive stats, hypothesis testing',
    calculators: [
      { id: 'descriptive', name: 'Descriptive Statistics', desc: 'Mean, median, SD, IQR' },
      { id: 'probability', name: 'Probability', desc: 'nCr, nPr, binomial, Poisson' },
      { id: 'hypothesis', name: 'Hypothesis Testing', desc: 'z-test, t-test, p-value' },
      { id: 'regression', name: 'Regression', desc: 'Linear, R², scatter plot' },
      { id: 'distribution', name: 'Distribution Tables', desc: 'Normal CDF, inverse lookup' },
    ],
  },
  {
    id: 'biology', name: 'Biology & Earth Science', icon: Dna, description: 'Genetics, population, astronomy',
    calculators: [
      { id: 'genetics', name: 'Genetics', desc: 'Hardy-Weinberg, Punnett square' },
      { id: 'population', name: 'Population Growth', desc: 'Exponential & logistic' },
      { id: 'body-metrics', name: 'Body Metrics', desc: 'BMI, BMR, TDEE' },
      { id: 'astronomy', name: 'Astronomy', desc: "Kepler's law, escape velocity" },
      { id: 'geoscience', name: 'Geoscience', desc: 'Richter scale, seismic waves' },
    ],
  },
  {
    id: 'text-numbers', name: 'Text & Numbers', icon: Type, description: 'Text case, word count, hash, number to words',
    calculators: [
      { id: 'text-case', name: 'Text Case Converter', desc: 'UPPERCASE, lowercase, Title, camelCase, snake_case' },
      { id: 'text-analysis', name: 'Word & Character Count', desc: 'Words, characters, reading time, frequent words' },
      { id: 'number-to-words', name: 'Number to Words', desc: 'Convert numbers to words (Indian + International)' },
      { id: 'hash-generator', name: 'Hash Generator', desc: 'MD5, SHA-1, SHA-256, SHA-512, CRC32' },
    ],
  },
];

export const allCalculators = calculatorCategories.flatMap(cat =>
  cat.calculators.map(calc => ({ ...calc, categoryId: cat.id, categoryName: cat.name }))
);
export const getCalculatorById = (id) => allCalculators.find(c => c.id === id);
export const getCategoryById = (id) => calculatorCategories.find(c => c.id === id);
